<template>
  <v-container class="grey lighten-4 fill-height" fluid>
    <v-row>
      <v-col cols="12" sm="6">
        <v-row
          align="start"
          justify="start"
        >
          <v-col
            cols="12"
          >
            <v-card elevation="0">
              <v-carousel 
                height="400"
                hide-delimiter-background
                show-arrows-on-hover
              >
                <v-carousel-item
                >
                  <v-img
                    :src="require('../assets/edu1.jpg')"
                    :lazy-src="require('../assets/edu1.jpg')"
                    height="100%"
                    class="white--text align-start"
                    gradient="to bottom, rgba(0,0,0,.5), rgba(0,0,0,.0)"
                  >
                    <v-list-item>
                      <v-list-item-avatar>
                        <v-avatar size="24">
                          <img
                            :src="require('../assets/edu2.jpg')"
                            alt="Eduardo Mendes Eletricista Residencial"
                            contain
                          >
                        </v-avatar>
                        
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <!--
                        <v-list-item-subtitle>
                        Fornecido e entregue por:
                        </v-list-item-subtitle>
                        -->
                        <v-list-item-subtitle class="white--text">
                        <span class="caption font-weight-light">Fornecido e entregue por:<br></span> Eduardo Mendes Eletricista Residencial
                        </v-list-item-subtitle>                                 
                      </v-list-item-content>
                    </v-list-item>
                  </v-img>  
                </v-carousel-item>
                <v-carousel-item
                >
                  <v-img
                    :src="require('../assets/edu2.jpg')"
                    :lazy-src="require('../assets/edu2.jpg')"
                    height="100%"
                    class="white--text align-start"
                    gradient="to bottom, rgba(0,0,0,.5), rgba(0,0,0,.0)"
                  >
                    <v-list-item>
                      <v-list-item-avatar>
                        <v-avatar size="24">
                          <img
                            :src="require('../assets/edu2.jpg')"
                            alt="Eduardo Mendes Eletricista Residencial"
                            contain
                          >
                        </v-avatar>
                        
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <!--
                        <v-list-item-subtitle>
                        Fornecido e entregue por:
                        </v-list-item-subtitle>
                        -->
                        <v-list-item-subtitle class="white--text">
                        <span class="caption font-weight-light">Fornecido e entregue por:<br></span> Eduardo Mendes Eletricista Residencial
                        </v-list-item-subtitle>                                 
                      </v-list-item-content>
                    </v-list-item>
                  </v-img>  
                </v-carousel-item>
                <v-carousel-item
                >
                  <v-img
                    :src="require('../assets/edu3.jpg')"
                    :lazy-src="require('../assets/edu3.jpg')"
                    height="100%"
                    class="white--text align-start"
                    gradient="to bottom, rgba(0,0,0,.5), rgba(0,0,0,.0)"
                  >
                    <v-list-item>
                      <v-list-item-avatar>
                        <v-avatar size="24">
                          <img
                            :src="require('../assets/edu2.jpg')"
                            alt="Eduardo Mendes Eletricista Residencial"
                            contain
                          >
                        </v-avatar>
                        
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <!--
                        <v-list-item-subtitle>
                        Fornecido e entregue por:
                        </v-list-item-subtitle>
                        -->
                        <v-list-item-subtitle class="white--text">
                        <span class="caption font-weight-light">Fornecido e entregue por:<br></span> Eduardo Mendes Eletricista Residencial
                        </v-list-item-subtitle>                                 
                      </v-list-item-content>
                    </v-list-item>
                  </v-img>  
                </v-carousel-item>
                <v-carousel-item
                >
                  <v-img
                    :src="require('../assets/edu4.jpg')"
                    :lazy-src="require('../assets/edu4.jpg')"
                    height="100%"
                    class="white--text align-start"
                    gradient="to bottom, rgba(0,0,0,.5), rgba(0,0,0,.0)"
                  >
                    <v-list-item>
                      <v-list-item-avatar>
                        <v-avatar size="24">
                          <img
                            :src="require('../assets/edu2.jpg')"
                            alt="Eduardo Mendes Eletricista Residencial"
                            contain
                          >
                        </v-avatar>
                        
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <!--
                        <v-list-item-subtitle>
                        Fornecido e entregue por:
                        </v-list-item-subtitle>
                        -->
                        <v-list-item-subtitle class="white--text">
                        <span class="caption font-weight-light">Fornecido e entregue por:<br></span> Eduardo Mendes Eletricista Residencial
                        </v-list-item-subtitle>                                 
                      </v-list-item-content>
                    </v-list-item>
                  </v-img>  
                </v-carousel-item>
              </v-carousel>
              
              <!--<v-card-text><span class="body-2 font-weight-light">entregue por: </span> <v-icon small left>mdi-store</v-icon><span class="body-2 font-weight-bold">{{vendedor.nome}}</span></v-card-text>-->
            </v-card>  
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6">
        <v-row
          justify="start"
          align="start"
        >
          <v-col
            cols="12"
          >
            <v-card elevation="0">
              <v-card-title>
                <h2 class="headline font-weight-bold">Instalação e Manutenção Elétrica Residencial</h2>
                <span class="body-2 font-weight-light"><v-icon x-small left>mdi-map-marker</v-icon>Atendemos todo Rio de Janeiro</span>
                <!--{{vendedor.endereco.bairro}}, {{vendedor.endereco.cidade}}-->
              </v-card-title>
              <v-divider class="mx-4"></v-divider>
              <v-card-text>
                Precisando de Instalação ou manutenção elétrica?
                Instalação de lâmpadas, tomadas, ventiladores de teto, chuveiros elétricos, quadro de distrubuição de circuito: monofásico, bifásico ou trifásico, bomba de poço, fotocélula, sensores de presença, entrada padrão da light, tree-way, manutenção elétrica e muito mais...  
              </v-card-text>   
              <v-divider class="mx-4"></v-divider>
              <v-card-text>
                <span class="subheading"><strong>Selecione o tipo de serviço:</strong></span>

                <v-chip-group
                  v-model="selection"
                  active-class="indigo white--text"
                  mandatory
                >
                  <v-chip
                    v-for="size in sizes"
                    :key="size"
                    :value="size"
                    filter
                    label
                  >
                    {{ size }}
                  </v-chip>
                </v-chip-group>
              </v-card-text>          
              <v-card-text>
                                
                <v-row justify="start">
                  <!--<v-icon @click="quantidade--">mdi-minus</v-icon>-->
                  
                  <!--
                  <v-col cols="6" sm="4">
                    <v-spacer></v-spacer>
                    <v-btn
                      x-large
                      color="indigo lighten-1 white--text"
                      v-on="on"
                      item
                      block
                      @click="verificaStatus"
                    >
                      <v-icon left>mdi-calendar-month</v-icon>
                       Reservar
                    </v-btn>
                  </v-col>  
                  -->
                  <v-col cols="12" sm="8">  
                    <!--
                    <v-btn v-if="consultaEstoque(ads['.key'], ads.quantidade)<=0"
                      x-large
                      color="red lighten-1 white--text"
                      text
                      block
                    >
                      <v-icon left>mdi-close-circle</v-icon>
                      Produto Esgotado 
                    </v-btn>
                    -->
                    <v-btn
                      x-large
                      color="green lighten-1 white--text"
                      item
                      block
                      :href="`https://api.whatsapp.com/send?phone=5521981352741&text=Solicito: Orçamento de ${selection} do Eletricista`" 
                      target="_blank"
                    >
                      <v-icon left>mdi-whatsapp</v-icon>
                      Faça seu orçamento grátis
                    </v-btn>
                    <!-- Começo do Diálogo -->

                      
                    <!-- Fim do Diálogo -->
                  </v-col>
                </v-row>      
              </v-card-text>
            </v-card>
            <!--
            <v-card
              v-for="(url, n) in ads.imagem"
              :key="n"
            >
              <v-img
                :src="url"
                :lazy-src="url"
                height="100%"
              >
              </v-img>
              <v-divider></v-divider>  
            </v-card>  
            -->
            <v-card elevation="0">
              <v-list dense>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-action>
                    <v-btn icon>
                      <v-icon color="green lighten-1">mdi-check</v-icon>
                    </v-btn>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Pague somente no ato ao técnico</v-list-item-title>
                    <v-list-item-subtitle>Sem taxa de reserva ou cartão de crédito no site</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-action>
                    <v-btn icon>
                      <v-icon color="green lighten-1">mdi-check</v-icon>
                    </v-btn>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Confirmação Imediata</v-list-item-title>
                    <v-list-item-subtitle>Não é necessário criar conta no site</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-action>
                    <v-btn icon>
                      <v-icon color="green lighten-1">mdi-check</v-icon>
                    </v-btn>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Cancelamento Gratuito</v-list-item-title>
                    <v-list-item-subtitle>Cancele em até 24h antes do dia do atendimento sem taxas</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-action>
                    <v-btn icon>
                      <v-icon color="green lighten-1">mdi-check</v-icon>
                    </v-btn>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Atendimento  <span style="color:red">(24h)</span></v-list-item-title>
                    <v-list-item-subtitle>Dias úteis 24h</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              
              <v-divider></v-divider>  
              <!--
              <iframe width="100%" height="250" src="https://www.youtube.com/embed/zgwwb4NOvOk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              <v-divider></v-divider>
              <v-chip
                class="ma-2"
                color="primary"
                text-color="white"
                small
                label
                @click="url('https://jmrclimatizacao.com')"
              >
              <v-icon small left>
                  mdi-check-decagram
                </v-icon>
                jmrclimatizacao.com
              </v-chip>      
              <v-chip
                class="ma-2"
                color="error"
                text-color="white"
                small
                label
              >
              <v-icon small left>
                  mdi-youtube
                </v-icon>
                Youtube
              </v-chip>
              <v-chip
                class="ma-2"
                color="error"
                text-color="white"
                small
                label
              >
              <v-icon small left>
                  mdi-instagram
                </v-icon>
                Instagram
              </v-chip>      
              -->
              <!--
              <v-simple-table v-if="filtroTamanhoAcessorio(ads.acessorios)==true">
                <thead>
                  <tr>
                    <th class="text-left">Item</th>
                    <th class="text-left">Quantidade</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="acessorio in filtroAcessorio(ads.acessorios)" :key="acessorio.tipo">
                    <td>{{arraynomeacessorio[acessorio.tipo]}}</td>
                    <td>{{acessorio.valor}}</td>
                  </tr>
                </tbody>
              </v-simple-table>
              <v-divider></v-divider>
              <v-card-text dense class="black--text">
                {{ titulo }} - <span class="body-2 font-weight-light">{{ descricao }}</span>
              </v-card-text>
              <v-divider></v-divider>
              <div v-if="ads.perguntas">
                <v-list
                  subheader
                  dense
                  three-line
                  v-for="(pergunta, i) in filtroPerguntas(ads.perguntas)" :key="pergunta.pergunta"
                >
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>{{i+1}}) {{pergunta.pergunta}}</v-list-item-title>
                      <v-list-item-subtitle>R: {{pergunta.resposta}}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div> 
              -->            
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12">
            
      </v-col>
      
      <!--
      <v-col cols="12" sm="6">
        <v-card>
          <v-card-title>Detalhes Adicionais</v-card-title>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">Calories</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in desserts" :key="item.name">
                  <td>{{ item.name }}</td>
                  <td>{{ item.calories }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>    
      </v-col>          
      -->
    </v-row>  
  </v-container>
</template>

<script>
  //const that = this.key;
  export default {
    data: () => ({
      selection: 'Instalação elétrica',
      sizes: [
        'Instalação elétrica',
        'Manutenção elétrica' 
      ],
    }),
  }  
</script>